export const types = {
  COACH_PAYMENT: 'coachPayment',
  SAVE_PROGRAM_INVITE:'saveprograminvite',
  GOLD: 'Gold',
  PLATINUM: 'Platinum'
};
